import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  EntityModelSwissLipidsEntry,
  PagedModelEntityModelSwissLipidsEntry,
  SwissLipidsEntry,
  SwissLipidsEntryControllerService
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import {
  JobsService,
  JobFileInputDto
} from "../../../../modules/lipidcompass-data-importer-client";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-admin-swisslipids",
  templateUrl: "./admin-swisslipids.component.html",
  styleUrls: ["./admin-swisslipids.component.css"],
  standalone: true,
  imports: [ButtonModule, CrudTableComponent, SelectModule, FormsModule]
})
export class AdminSwissLipidsComponent implements OnInit {
  private controller = inject(SwissLipidsEntryControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private jobControllerService = inject(JobsService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[];
  filterFields: string[];
  crudAdapter: CrudAdapter<
    PagedModelEntityModelSwissLipidsEntry,
    EntityModelSwissLipidsEntry
  >;
  fileOptions: string[];
  file: string;

  ngOnInit() {
    this.jobControllerService
      .listFilesForJobName("swissLipidsImportJob")
      .subscribe(
        response => {
          this.fileOptions = response?._embedded?.stringList;
        },
        error => {
          this.messageService.add({
            severity: "error",
            summary: "Job config failed",
            detail: "Job config failed to load"
          });
        }
      );
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "id",
        header: "Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "transactionUuid",
        header: "Transaction",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "normalizedName",
        header: "Shorthand Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "description",
        header: "Description",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "abbreviation",
        header: "SwissLipids Abbr",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "nativeId",
        header: "SwissLipids Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "nativeUrl",
        header: "SwissLipids Entry",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "level",
        header: "Level",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      // {
      //   field: "label",
      //   header: "Label",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "name",
      //   header: "Name",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "version",
      //   header: "Version",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "uri",
      //   header: "Uri",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      {
        field: "visibility",
        header: "Visibility",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      }
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new SwissLipidsEntryCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }

  importSwissLipids() {
    const jobFileInputDto: JobFileInputDto = {
      file: this.file
    };
    this.jobControllerService
      .startJob("swissLipidsImportJob", jobFileInputDto)
      .subscribe(
        response => {
          this.messageService.add({
            severity: "success",
            summary: "Job started",
            detail: "Job started successfully"
          });
        },
        error => {
          this.messageService.add({
            severity: "error",
            summary: "Job failed",
            detail: "Job failed to start"
          });
        }
      );
  }
}
class SwissLipidsEntryCrudAdapter extends CrudAdapter<
  PagedModelEntityModelSwissLipidsEntry,
  EntityModelSwissLipidsEntry
> {
  constructor(
    private controller: SwissLipidsEntryControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelSwissLipidsEntry> {
    return this.controller.swissLipidsEntryGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  extractEntries(entries: any): EntityModelSwissLipidsEntry[] {
    return <EntityModelSwissLipidsEntry[]>(
      entries?._embedded?.swissLipidsEntries
    );
  }

  saveSingle(
    entity: EntityModelSwissLipidsEntry,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelSwissLipidsEntry> {
    return this.controller.swissLipidsEntrySaveSingle(
      <SwissLipidsEntry>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.swissLipidsEntryDeleteById(id, observe, reportProgress, options);
  }
}
